import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000/api';

export const login = async (usuario, clave) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, { usuario, clave });
    const { accessToken, refreshToken, user } = response.data.data;

    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('user', JSON.stringify(user));

    return { success: true, token: accessToken, user };
  } catch (error) {
    return { success: false, message: error.response?.data?.error || 'Error en login' };
  }
};

export const logout = () => {
  const refreshToken = localStorage.getItem('refreshToken');
  if (refreshToken) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    axios.post(`${API_URL}/auth/logout`, { refreshToken }).catch((_e) => { /* intento silencioso */ });
  }
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
};

export const getToken = () => localStorage.getItem('accessToken');

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
};

export const isAuthenticated = () => !!getToken();
